/**
 * Cross-component event names for the Medicines section. Kept in a standalone
 * module (no default export, no hooks) so imports don't accidentally pull in
 * the Medicines component — see chiefComplaints/events.js for why.
 */
export const MED_V2_REFRESH = "med-v2:refresh";

/**
 * Open a blank Add sheet in the editor rail (board 2964:4270 moved the write
 * surface from floating dialogs into the third column, like every other v3
 * section).
 */
export const MED_V2_ADD = "med-v2:add";

/**
 * Open the Update sheet for one medicine in the same rail. Carries
 * `{ medicine, mode: "status" }` — the marker is how the rail tells an
 * update sheet from a blank add, because the channels share one listener.
 * Dedup is by medicineId, so one row never has two racing update sheets.
 */
export const MED_V2_STATUS = "med-v2:status";

/**
 * Open a blank Adherence Review sheet in the editor rail for one medicine.
 * Payload `{ medicine, mode: "adherence" }` — same dedup rule as STATUS
 * (one sheet per medicineId). A NEW review is always created (green
 * icon means "at least one review saved", not "review is editable" —
 * clicking again opens a fresh blank sheet).
 */
export const MED_V2_ADHERENCE = "med-v2:adherence";

/**
 * Transcript-mode re-edit of an already-staged captured item. Fired
 * when the reviewer clicks a captured (peach) row's status chip so
 * the CapturedSections rail can pop the AI proposal back open for a
 * second pass instead of routing to the standalone Update sheet.
 * Payload `{ captured, medv2Record }` — medv2Record is null for a
 * staged-add row (no live Med v2 record yet) and the row itself when
 * the captured item is a staged-update on an existing record.
 * Mirrors CC_V2_EDIT_CAPTURED / DX_V2_EDIT_CAPTURED.
 */
export const MED_V2_EDIT_CAPTURED = "med-v2:edit-captured";
